import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import ModalBooking from '../../components/ModalBooking';
import InitialData from '../../../InitialData';

function DropdownBooking() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedApartment, setSelectedApartment] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (apartment) => {
    setSelectedApartment(apartment);
    setModalOpen(true);
    handleClose();
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedApartment(null);
  };

  return (
    <div style={{ width: '100%', maxWidth: 320, textAlign: 'center' }}>
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          my: { xs: 1, sm: 2 },
          whiteSpace: 'normal',
          lineHeight: 1.2,
        }}
      >
        {t('booking.selectApartment')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: 'calc(100vw - 32px)', sm: 'auto' },
            maxWidth: 360,
          },
        }}
      >
        {InitialData.map((apartment) => (
          <MenuItem key={apartment.id} onClick={() => handleSelect(apartment)}>
            {apartment.name}
          </MenuItem>
        ))}
      </Menu>

      {selectedApartment && (
        <ModalBooking
          open={modalOpen}
          onClose={handleModalClose}
          apartment={selectedApartment}
        />
      )}
    </div>
  );
}

export default DropdownBooking;
